import { Injectable } from '@angular/core';
import { Query, gql, QueryRef } from 'apollo-angular';
import {
  NegotiationDetails,
  NegotiationDetailsResponse,
} from '../components/negotiations/negotiations.model';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NegotiationDetailsService extends Query<NegotiationDetailsResponse> {
  private negotiation: NegotiationDetails;
  private negotiationQueryRef: QueryRef<NegotiationDetailsResponse>;

  setNegotiationQueryRef(queryRef: QueryRef<NegotiationDetailsResponse>) {
    this.negotiationQueryRef = queryRef;
  }

  refresh() {
    return this.negotiationQueryRef.refetch();
  }

  getActiveNegotiationDetails(): NegotiationDetails {
    return this.negotiation;
  }

  setActiveNegotiationDetails(details: NegotiationDetails) {
    this.negotiation = details;
    // console.log('setting negotiation in Serc=vice: ',this.negotiation)
  }

  document = gql`
    query NegotiationDetailsQuery($id: String!) {
      negotiation(id: $id) {
        _id
        user_id
        lot_user_id
        lot_id
        lot_type
        createdAt

        counters {
          originator_id
          price_value {
            __typename
            ... on CashPrice {
              amount
            }

            __typename
            ... on BasisPrice {
              month
              year
              basisPoints
              product_code
            }
          }
          volume_value
          ship_begin
          ship_end
          created_at
        }

        origin
        lot_type
        commodity
        grade
        product_type
        specifications {
          title
          value
        }

        documentations {
          title
          value
        }
        price_value_orig {
          __typename
          ... on CashPrice {
            amount
          }

          __typename
          ... on BasisPrice {
            month
            year
            basisPoints
            product_code
          }
        }
        currency
        volume_value_orig
        price_units
        units
        ship_begin_orig
        ship_end_orig
        destination
        delivery_type
        container_type
        delivery_option
        additional_info
        payment_term
        status
        packaging
        tolerance
        rules_to_govern
        weight_grade_to_govern
      }
    }
  `;
}
